<template>
  <b-card
    no-body
    border-variant="primary"
    class="w-fit mb-0"
  >
    <b-row
      align-v="center"
      class="p-1 m-0"
    >
      <b-col>
        <ProductItem
          :img="data.images.length ? data.images[0].image_url : null"
          :title="data.name"
          :subtitle="data.merchant ? data.merchant.name : ''"
          :clamp="clamp"
          :variant-data="withVariant ? getVariantName(variantData.details) : ''"
        />
      </b-col>
      <b-col
        v-if="isHaveAction"
        cols="auto"
        class="text-right p-0"
      >
        <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          variant="flat-danger"
          class="btn-icon rounded-circle"
          @click="$emit('delete')"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'
import ProductItem from '@/layouts/components/custom/ProductItem.vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    ProductItem,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    clamp: {
      type: Number,
      default: 0,
    },
    withVariant: {
      type: Boolean,
      default: false,
    },
    variantData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isHaveAction() {
      return this.canDelete
    },
  },
  methods: {
    getVariantName(data) {
      const list = data.map(el => el.value)
      return list.toString()
    },
  },
}
</script>
